import React from 'react';
import Component from '../../components/Component';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {RxForm, Form, FormField, FormManager} from 'reactis-forms';
import {FilterInput, DatePicker, Number, Select, SearchInput, Handsontable} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar,Tooltip, OverlayTrigger, Popover} from 'react-bootstrap';
import {AlertWindow, ModalWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DocumentTitle from 'react-document-title';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getWindowSize} from '../../utils/utils';
import * as actions from '../../redux/modules/calendar';
import {actions as formActions} from 'reactis-forms';
import dots from 'dots';
import Moment from 'moment';
import immutable from 'immutable';
import {Panel, Tabs, Tab} from 'react-bootstrap';
import MonthPicker from '../../components/Form/MonthPagePicker';
import AdminForm from './AdminForm';
import DayCell from './DayCell';
import NavBar from '../../components/NavBar';
import classnames from 'classnames';

@connect((state, props) => {
	return {
		state: state.calendar.get('month').toJS()
	};
}, (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch),
		formActions: bindActionCreators(formActions, dispatch)
	};
}, null, {withRef: true })
export default class Calendar extends Component {

	static contextTypes = {
		router: React.PropTypes.object,
		store: React.PropTypes.object,
		user: React.PropTypes.object,
		flashMessage: React.PropTypes.func
	};

	constructor(props, context) {
		super(props);
		this.formView = new FormManager({
			date: {
				class: MonthPicker,
				label: 'Datum',
				type: 'month',
				width: 90,
				value: props.date
			}
		});
	}

	componentDidMount() {
		this.load();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.date != this.props.date) {
			this.load(nextProps.date);
		}
		if (nextProps.state.data != this.props.state.data) {

		}
	}

	load(date = this.props.date) {
		this.props.actions.load(new Moment(date).format('YYYY-MM-DD'));
	}

	handleDayClick(day) {
		const win = new ModalWindow(new Moment(day).format('D.M.YYYY'),
			<AdminForm onClose={() => win.hide()}
					   forceLoad={true}
					   onSave={() => { win.hide(); this.load()}}
					   id={new Moment(day).format('YYYY-MM-DD')}
					   date={new Moment(day).format('D.M.YYYY')} />);
		const isPhone = window.matchMedia("only screen and (max-width: 768px)").matches;
		win.animation = !isPhone;
		win.show(this.context.store.dispatch);
	}

	render() {

		const isAdmin = true;

		const dayLabels = ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle'];
		const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		const currentDate = new Date();
		const currentDay = currentDate.getDate();
		const currentMonth = currentDate.getMonth();
		const currentYear = currentDate.getFullYear();

		const m = new Moment(this.props.date);
		const year = m.year();
		const month = m.month();
		const firstDay = new Date(year, month, 1);
		let startingDay = firstDay.getDay() - 1;
		if (startingDay == -1) {
			startingDay = 6;
		}

		let monthLength = daysInMonth[month];
		if (month == 1) {
			if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
				monthLength = 29;
			}
		}
		const weeks = [];

		const isPhone = window.matchMedia("only screen and (max-width: 768px)").matches;
		let calendar;

		if (!isPhone) {
			let day = 1;
			for (let i = 0; i < 9; i++) {
				let week = [];
				for (let j = 0; j <= 6; j++) {
					if (day <= monthLength && (i > 0 || j >= startingDay)) {
						const current = day === currentDay && month == currentMonth && year === currentYear;
						const date = new Date(year, month, day);
						const m = new Moment(date).hour(0);
						const data = this.props.state.data[m.format('YYYY-MM-DD')];
						const isWeekend = m.isoWeekday() == 6 || m.isoWeekday() == 7;
						const active = data && data.active;
						const cell = <DayCell onEditClick={() => this.handleDayClick(m)}
														date={date}
														data={data}
														weekend={isWeekend}/>;

						const cn = classnames({
							today:current,
							weekend: data && data.isHistory || isWeekend,
							'green-cell': !this.props.state.pending && active,
							'red-cell': !this.props.state.pending && !active
						});

						week.push(<td key={j} className={cn}>{cell}</td>);
						day++;
					} else {
						week.push(<td key={j}/>);
					}
				}
				weeks.push(<tr key={i}>{week}</tr>);
				if (day > monthLength) {
					break;
				}
			}
			calendar = <table className="calendar">
				<thead>
				<tr className="day-labels">
					{dayLabels.map((label, index)=> {
						return <td key={index} style={{padding: 4}}><small>{label}</small></td>
					})}
				</tr>
				</thead>
				<tbody>
				{weeks}
				</tbody>
			</table>;
		}
		else {
			let day = 1;
			for (let i = 0; i < 9; i++) {
				let week = [];
				for (let j = 0; j <= 6; j++) {
					if (day <= monthLength && (i > 0 || j >= startingDay)) {
						const current = day === currentDay && month == currentMonth && year === currentYear;
						const date = new Date(year, month, day);
						const m = new Moment(date).hour(0);
						const data = this.props.state.data[m.format('YYYY-MM-DD')];
						const isWeekend = m.isoWeekday() == 6 || m.isoWeekday() == 7;
						const active = data && data.active;
						const cell = <DayCell compact={true} onEditClick={() => this.handleDayClick(m)}
														date={date}
														data={data}
														weekend={isWeekend}/>;

						const cn = classnames({
							today:current,
							weekend: data && data.isHistory || isWeekend,
							'green-cell': !this.props.state.pending && active,
							'red-cell': !this.props.state.pending && !active
						});
						week.push(<table className="calendar" style={{width:'100%',border: '1px solid #AAA', marginBottom: 2}}>
									<tbody>
									<tr><td key={j} className={cn}>{cell}</td></tr>
									</tbody>
									</table>);
						day++;
					}
				}
				weeks.push(week);
				if (day > monthLength) {
					break;
				}
			}
			calendar = <div className="responsive-calendar">
				{weeks}
				</div>;
		}


		return (
			<div className="tdidocument">
				<DocumentTitle title="Kalendář" />
				<NavBar />
				<div className="panel" style={{paddingBottom: 0, minHeight: 680}}>
					<div style={{padding:'10px 30px 20px 30px'}}>
						<h5 style={{float:'left'}}>{DbInfo.Month.get(new Moment(this.props.date).month()+1)} {new Moment(this.props.date).year()}</h5>
						<RxForm form={this.formView} id="calendar.month.view">
							<div className="form" style={{textAlign:'center'}}>
								<FormField name="date" />
							</div>
						</RxForm>
						<hr/>
						{calendar}
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/Calendar.js